module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.handleScroll),
      expression: "handleScroll"
    }]
  }, [_c('div', {
    staticClass: "page profile-grid-page mx-5",
    class: {
      onMobile: _vm.onMobile
    }
  }, [(
    !(
      _vm.currentUser &&
      _vm.user.id != _vm.currentUser.id &&
      _vm.user.username != _vm.PublicRelationsUsername
    )
  ) ? _c('content-top-header', {
    staticClass: "border-bottom-x",
    attrs: {
      "height": "auto"
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "user-top-wrapper"
  }, [(_vm.user) ? _c('li', {
    staticClass: "user-profile-section"
  }, [_c('div', {
    staticClass: "user-profile-image-section",
    class: {
      live: _vm.show_stream_live_button
    },
    on: {
      "click": function($event) {
        _vm.show_stream_live_button &&
          !_vm.view_stream_clicked &&
          _vm.viewStream()
      }
    }
  }, [_c('div', {
    staticClass: "user-profile-image-own",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-info-section"
  }, [_c('div', {
    staticClass: "user-name-section"
  }, [_c('label', {
    staticClass: "display-name-own"
  }, [_vm._v("\n                  " + _vm._s(_vm.user.username) + "\n                  "), (
    ['artist', 'label', 'brand'].indexOf(_vm.user.user_type) >
    -1
  ) ? _c('v-icon', {
    staticClass: "user-status online"
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.followMetaVisible && !_vm.onMobile) ? _c('div', {
    staticClass: "user-status-section mt-0"
  }, [_c('div', {
    staticClass: "follower-count stat-count",
    on: {
      "click": function($event) {
        _vm.onTab('followers')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.user.followers)))]), _vm._v("\n                  Followers\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "follower-count stat-count",
    on: {
      "click": function($event) {
        _vm.onTab('followings')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm.user.followings))]), _vm._v("\n                  Following\n                ")]), _vm._v(" "), (_vm.user.user_type === 'listener' && _vm.user.inviter) ? [_c('div', {
    staticClass: "vertical-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "user-inviter-name"
  }, [_vm._v("\n                    Invited by\n                    "), _c('router-link', {
    attrs: {
      "to": ("/" + (_vm.user.inviter.slug))
    }
  }, [_vm._v(_vm._s(_vm.user.inviter.username))])], 1)] : _vm._e()], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('li', {
    staticClass: "user-action-section"
  }, [_c('v-btn', {
    staticClass: "play-btn",
    nativeOn: {
      "click": function($event) {
        _vm.playSong()
      }
    }
  }, [_c('v-icon', [_vm._v("play_arrow")]), _vm._v(" "), _c('span', [_vm._v("Play")])], 1)], 1), _vm._v(" "), (
    _vm.currentUser &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.username != _vm.PublicRelationsUsername
  ) ? [_c('li', [_c('user-follow-btn', {
    attrs: {
      "user": _vm.user,
      "theme": "dark",
      "type": "default",
      "borderRadius": ""
    }
  })], 1), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "message-btn mt-2",
    staticStyle: {
      "opacity": "0.8"
    },
    attrs: {
      "src": require('@/assets/mail_icon_outline.svg'),
      "alt": "mail icon",
      "width": "25"
    },
    on: {
      "click": function($event) {
        _vm.showMessageDialog()
      }
    }
  })]), _vm._v(" "), (
    _vm.currentUser &&
    _vm.currentUser.creator_verified &&
    _vm.user.stripe_connected &&
    _vm.user.creator_verified &&
    _vm.user.id != _vm.currentUser.id
  ) ? _c('li', [_c('img', {
    staticClass: "donate-btn mt-2",
    staticStyle: {
      "opacity": "0.8"
    },
    attrs: {
      "src": require('../../../static/images/ic_dollar.svg'),
      "alt": "circled dollar icon",
      "width": "25"
    },
    on: {
      "click": function($event) {
        _vm.showLoveDialog()
      }
    }
  })]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('li', [(
    _vm.currentUser &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.username != _vm.PublicRelationsUsername
  ) ? _c('v-menu', {
    staticClass: "more-menu",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    staticClass: "more-btn",
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [(_vm.enabledViewDirectMessage) ? _c('v-list-tile', {
    key: "view_direct_messages",
    on: {
      "click": function($event) {
        _vm.viewDirectMessages()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('label', [_vm._v("View Direct Messages")])])], 1) : _vm._e(), _vm._v(" "), (
    _vm.currentUser &&
    _vm.currentUser.creator_verified &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.stripe_connected &&
    _vm.user.creator_verified
  ) ? _c('v-list-tile', {
    key: "send_love",
    on: {
      "click": function($event) {
        _vm.showLoveDialog()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('label', [_vm._v("Donate")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.flagUser()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('label', [_vm._v("Flag")])])], 1)], 1)], 1) : _vm._e()], 1)], 2)])], 2) : _vm._e(), _vm._v(" "), (
    _vm.currentUser &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.username != _vm.PublicRelationsUsername &&
    !_vm.show_following_scroll
  ) ? _c('content-top-header', {
    attrs: {
      "height": "auto"
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "user-top-wrapper"
  }, [(_vm.user) ? _c('li', {
    staticClass: "user-profile-section"
  }, [_c('div', {
    staticClass: "user-profile-image-section",
    class: {
      live: _vm.show_stream_live_button
    },
    on: {
      "click": function($event) {
        _vm.show_stream_live_button &&
          !_vm.view_stream_clicked &&
          _vm.viewStream()
      }
    }
  }, [_c('div', {
    staticClass: "user-profile-image",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.url + ')',
    })
  }), _vm._v(" "), (_vm.followMetaVisible && _vm.onMobile) ? _c('div', {
    staticClass: "user-status-section mt-2"
  }, [_c('label', {
    staticClass: "follower-count",
    on: {
      "click": function($event) {
        _vm.onTab('followers')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.user.followers)))]), _vm._v(" "), _c('div', {
    staticClass: "_label"
  }, [_vm._v("Followers")])]), _vm._v(" "), _c('label', {
    staticClass: "vertical-divider"
  }), _vm._v(" "), _c('label', {
    staticClass: "follower-count",
    on: {
      "click": function($event) {
        _vm.onTab('followings')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.user.followings)))]), _vm._v(" "), _c('div', {
    staticClass: "_label"
  }, [_vm._v("Following")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "live-btn"
  }, [_vm._v("Live")])]), _vm._v(" "), _c('div', {
    staticClass: "user-info-section"
  }, [_c('div', {
    staticClass: "user-name-section"
  }, [_c('span', {
    staticClass: "user-role"
  }, [_vm._v(_vm._s(_vm.user.user_type))]), _vm._v(" "), _c('div', {
    staticClass: "display-name"
  }, [_vm._v("\n                  " + _vm._s(_vm.user.username) + "\n                  "), (
    ['artist', 'label', 'brand'].indexOf(_vm.user.user_type) >
    -1
  ) ? _c('v-icon', {
    staticClass: "user-status online"
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "user-following-section"
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [(
    _vm.currentUser &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.username != _vm.PublicRelationsUsername
  ) ? [_c('div', [_c('user-follow-btn', {
    attrs: {
      "user": _vm.user,
      "theme": "blue",
      "type": "default",
      "borderRadius": ""
    }
  })], 1), _vm._v(" "), _c('div', [(_vm.user.membership_tiers) ? _c('v-btn', {
    staticClass: "member-btn",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.showMembershipDialog()
      }
    }
  }, [_c('v-icon', [_vm._v("lock")]), _vm._v("\n                        Members\n                      ")], 1) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ml-2"
  }, [(
    _vm.currentUser &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.username != _vm.PublicRelationsUsername
  ) ? _c('v-menu', {
    staticClass: "more-menu",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    staticClass: "more-btn",
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [(_vm.enabledViewDirectMessage) ? _c('v-list-tile', {
    key: "view_direct_messages",
    on: {
      "click": function($event) {
        _vm.viewDirectMessages()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('label', [_vm._v("View Direct Messages")])])], 1) : _vm._e(), _vm._v(" "), (
    _vm.currentUser &&
    _vm.currentUser.creator_verified &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.stripe_connected &&
    _vm.user.creator_verified
  ) ? _c('v-list-tile', {
    key: "send_love",
    on: {
      "click": function($event) {
        _vm.showLoveDialog()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('label', [_vm._v("Donate")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('div', {
    staticClass: "dlfex align-center menu-list-div px-2"
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": require("../../assets/message_icon.svg"),
      "width": "12"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Message")])])])], 1), _vm._v(" "), _c('v-list-tile'), _vm._v(" "), _c('v-list-tile', {
    key: "block",
    on: {
      "click": function($event) {
        _vm.openBlockUserConfirmDialog()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('div', {
    staticClass: "dlfex align-center menu-list-div px-2"
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": require("../../assets/vlovk.svg"),
      "width": "12"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Block")])])])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.flagUser()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('div', {
    staticClass: "dlfex align-center menu-list-div px-2",
    on: {
      "click": function($event) {
        _vm.flagUser()
      }
    }
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": require("../../assets/report.svg"),
      "width": "12"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Report")])])])], 1)], 1)], 1) : _vm._e()], 1)], 2), _vm._v(" "), (_vm.followMetaVisible && !_vm.onMobile) ? _c('div', {
    staticClass: "user-status-section"
  }, [_c('label', {
    staticClass: "follower-count stat-count",
    on: {
      "click": function($event) {
        _vm.onTab('followers')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.user.followers)))]), _vm._v("\n                    Followers")]), _vm._v(" "), _c('label', {
    staticClass: "follower-count stat-count",
    on: {
      "click": function($event) {
        _vm.onTab('followings')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm.user.followings))]), _vm._v("\n                    Following")]), _vm._v(" "), (_vm.user.user_type === 'listener' && _vm.user.inviter) ? [_c('label', {
    staticClass: "vertical-divider"
  }), _vm._v(" "), _c('label', {
    staticClass: "user-inviter-name"
  }, [_vm._v("\n                      Invited by\n                      "), _c('router-link', {
    attrs: {
      "to": ("/" + (_vm.user.inviter.slug))
    }
  }, [_vm._v(_vm._s(_vm.user.inviter.username))])], 1)] : _vm._e()], 2) : _vm._e()])])]) : _vm._e()])])], 2) : _vm._e(), _vm._v(" "), (
    _vm.currentUser &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.username != _vm.PublicRelationsUsername &&
    _vm.show_following_scroll
  ) ? _c('content-top-header', {
    staticClass: "special-scroll-header",
    attrs: {
      "height": "auto"
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "user-top-wrapper align-center"
  }, [(_vm.user) ? _c('li', [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('div', {
    staticClass: "user-profile-section my-0"
  }, [_c('div', {
    staticClass: "user-profile-image-section mr-3",
    class: {
      live: _vm.show_stream_live_button
    },
    on: {
      "click": function($event) {
        _vm.show_stream_live_button &&
          !_vm.view_stream_clicked &&
          _vm.viewStream()
      }
    }
  }, [_c('div', {
    staticClass: "user-profile-image small-img",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.url + ')',
    })
  }), _vm._v(" "), (_vm.followMetaVisible && _vm.onMobile) ? _c('div', {
    staticClass: "user-status-section mt-2"
  }, [_c('label', {
    staticClass: "follower-count",
    on: {
      "click": function($event) {
        _vm.onTab('followers')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.user.followers)))]), _vm._v(" "), _c('div', {
    staticClass: "_label"
  }, [_vm._v("Followers")])]), _vm._v(" "), _c('label', {
    staticClass: "vertical-divider"
  }), _vm._v(" "), _c('label', {
    staticClass: "follower-count",
    on: {
      "click": function($event) {
        _vm.onTab('followings')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.user.followings)))]), _vm._v(" "), _c('div', {
    staticClass: "_label"
  }, [_vm._v("Following")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "live-btn"
  }, [_vm._v("Live")])]), _vm._v(" "), _c('div', {
    staticClass: "user-info-section"
  }, [_c('div', {
    staticClass: "user-name-section small-text"
  }, [_c('div', {
    staticClass: "display-name "
  }, [_vm._v("\n                      " + _vm._s(_vm.user.username) + "\n                      "), (
    ['artist', 'label', 'brand'].indexOf(_vm.user.user_type) >
    -1
  ) ? _c('v-icon', {
    staticClass: "user-status online"
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "ml-4"
  }, [_c('ul', {
    staticClass: "width100"
  }, [_vm._l((_vm.tabs), function(tab) {
    return [(_vm.isAvailableForGridView(tab)) ? _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (['followings', 'followers'].indexOf(tab.id) == -1),
        expression: "['followings', 'followers'].indexOf(tab.id) == -1"
      }],
      key: tab.id,
      staticClass: "nav-li",
      class: [{
          'active tab-active': _vm.isActiveTab(tab.id)
        },
        ("nav-" + (tab.id)) ],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(tab.title) + "\n                      ")])]) : _vm._e()]
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "dflex align-center"
  }, [(_vm.followMetaVisible && !_vm.onMobile) ? _c('div', {
    staticClass: "user-status-section"
  }, [_c('label', {
    staticClass: "follower-count stat-count",
    on: {
      "click": function($event) {
        _vm.onTab('followers')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.user.followers)))]), _vm._v("\n                Followers")]), _vm._v(" "), _c('label', {
    staticClass: "follower-count stat-count",
    on: {
      "click": function($event) {
        _vm.onTab('followings')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm.user.followings))]), _vm._v("\n                Following")]), _vm._v(" "), _c('label', {
    staticClass: "follower-count stat-count"
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.smsCount)))]), _vm._v("\n                SMS\n              ")]), _vm._v(" "), (_vm.user.user_type === 'listener' && _vm.user.inviter) ? [_c('label', {
    staticClass: "vertical-divider"
  }), _vm._v(" "), _c('label', {
    staticClass: "user-inviter-name"
  }, [_vm._v("\n                  Invited by\n                  "), _c('router-link', {
    attrs: {
      "to": ("/" + (_vm.user.inviter.slug))
    }
  }, [_vm._v(_vm._s(_vm.user.inviter.username))])], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mb-2 ml-5"
  }, [_c('div', {
    staticClass: "dflex align-center mt-2"
  }, [(
    _vm.currentUser &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.username != _vm.PublicRelationsUsername
  ) ? [_c('div', [_c('user-follow-btn', {
    attrs: {
      "user": _vm.user,
      "theme": "blue",
      "type": "default",
      "borderRadius": ""
    }
  })], 1), _vm._v(" "), (
    _vm.currentUser &&
    _vm.currentUser.creator_verified &&
    _vm.user.stripe_connected &&
    _vm.user.creator_verified &&
    _vm.user.id != _vm.currentUser.id
  ) ? _c('div', [_c('img', {
    staticClass: "donate-btn mt-2",
    staticStyle: {
      "opacity": "0.8"
    },
    attrs: {
      "src": require('../../../static/images/ic_dollar.svg'),
      "alt": "circled dollar icon",
      "width": "25"
    },
    on: {
      "click": function($event) {
        _vm.showLoveDialog()
      }
    }
  })]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ml-2"
  }, [(
    _vm.currentUser &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.username != _vm.PublicRelationsUsername
  ) ? _c('v-menu', {
    staticClass: "more-menu",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    staticClass: "more-btn",
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [(_vm.enabledViewDirectMessage) ? _c('v-list-tile', {
    key: "view_direct_messages",
    on: {
      "click": function($event) {
        _vm.viewDirectMessages()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('label', [_vm._v("View Direct Messages")])])], 1) : _vm._e(), _vm._v(" "), (
    _vm.currentUser &&
    _vm.currentUser.creator_verified &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.stripe_connected &&
    _vm.user.creator_verified
  ) ? _c('v-list-tile', {
    key: "send_love",
    on: {
      "click": function($event) {
        _vm.showLoveDialog()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('label', [_vm._v("Donate")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('div', {
    staticClass: "dlfex align-center menu-list-div px-2"
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": require("../../assets/message_icon.svg"),
      "width": "12"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Message")])])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('div', {
    staticClass: "dlfex align-center menu-list-div px-2"
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": require("../../assets/dollar.svg"),
      "width": "12"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Donate")])])])], 1), _vm._v(" "), _c('v-list-tile', {
    key: "block",
    on: {
      "click": function($event) {
        _vm.openBlockUserConfirmDialog()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('div', {
    staticClass: "dlfex align-center menu-list-div px-2"
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": require("../../assets/vlovk.svg"),
      "width": "12"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Block")])])])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.flagUser()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('div', {
    staticClass: "dlfex align-center menu-list-div px-2",
    on: {
      "click": function($event) {
        _vm.flagUser()
      }
    }
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": require("../../assets/report.svg"),
      "width": "12"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Report")])])])], 1)], 1)], 1) : _vm._e()], 1)], 2)])])], 1)])], 2) : _vm._e(), _vm._v(" "), (_vm.show_following) ? _c('div', {
    staticClass: "followers-header"
  }, [_c('div', {
    staticClass: "followers-title"
  }, [_vm._v("Followers")])]) : _vm._e(), _vm._v(" "), (!_vm.show_following) ? _c('content-top-header', {
    attrs: {
      "absolute": ""
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "width100"
  }, [_vm._l((_vm.tabs), function(tab) {
    return [(_vm.isAvailableForGridView(tab)) ? _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (['followings', 'followers'].indexOf(tab.id) == -1),
        expression: "['followings', 'followers'].indexOf(tab.id) == -1"
      }],
      key: tab.id,
      staticClass: "nav-li",
      class: [{
          'active tab-active': _vm.isActiveTab(tab.id)
        },
        ("nav-" + (tab.id)) ],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v("\n                " + _vm._s(tab.title) + "\n              ")])]) : _vm._e()]
  })], 2)])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [(_vm.active_tab == 'followings' || _vm.active_tab == 'followers') ? _c('div', [(!_vm.users || _vm.users.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Profile is Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("It’s a little lonely in here...")]), _vm._v(" "), (_vm.currentUser && _vm.user.id == _vm.currentUser.id) ? _c('router-link', {
    staticClass: "empty-discover-btn",
    attrs: {
      "to": "/album"
    }
  }, [_vm._v("Discover")]) : _vm._e()], 1) : _c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.users), function(user, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "card-container",
      attrs: {
        "xs12": "",
        "sm2": ""
      }
    }, [_c('artist-item', {
      key: index,
      attrs: {
        "artist": user
      }
    })], 1)
  })), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page_index < _vm.total_pages),
      expression: "page_index < total_pages"
    }],
    staticClass: "loadmore-btn",
    nativeOn: {
      "click": function($event) {
        _vm.getItems(_vm.active_tab, true)
      }
    }
  }, [_vm._v("Load More")])], 1) : (_vm.active_tab == 'artists') ? _c('div', [(!_vm.users || _vm.users.length == 0) ? [(_vm.currentUser && _vm.currentUser.id == _vm.user.id) ? [_vm._m(0)] : [_vm._m(1)]] : _c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.users), function(user, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "card-container min-240",
      attrs: {
        "xs12": "",
        "sm2": ""
      }
    }, [_c('artist-item', {
      key: index,
      attrs: {
        "artist": user
      }
    })], 1)
  })), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page_index < _vm.total_pages),
      expression: "page_index < total_pages"
    }],
    staticClass: "loadmore-btn",
    nativeOn: {
      "click": function($event) {
        _vm.getItems(_vm.active_tab, true)
      }
    }
  }, [_vm._v("Load More")])], 2) : (_vm.active_tab == 'merch') ? _c('div', [(!_vm.products || _vm.products.length == 0) ? [(_vm.currentUser && _vm.currentUser.id == _vm.user.id) ? [(_vm.currentUser.creator_verified) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("\n                You have not uploaded any products\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "empty-discover-btn",
    attrs: {
      "to": "/product/add"
    }
  }, [_vm._v("Upload")])], 1) : _vm._e()] : [_vm._m(2)]] : _c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.products), function(product, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "card-container",
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('product-card', {
      attrs: {
        "dataObject": product,
        "hideOverlay": ""
      }
    })], 1)
  })), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page_index < _vm.total_pages),
      expression: "page_index < total_pages"
    }],
    staticClass: "loadmore-btn",
    nativeOn: {
      "click": function($event) {
        _vm.getItems(_vm.active_tab, true)
      }
    }
  }, [_vm._v("Load More")])], 2) : (_vm.active_tab === 'sms_group' && _vm.user.id == _vm.currentUser.id) ? _c('div', [_c('div', {
    staticClass: "sms-group pa-2"
  }, [_c('div', {
    staticClass: "dflex align-center justify-space-between"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "sms-btn-group mr-4"
  }, [_c('v-btn', {
    staticClass: "join-btn",
    attrs: {
      "round": ""
    }
  }, [_vm._v("Join SMS")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2 joined-btn",
    attrs: {
      "round": ""
    }
  }, [_vm._v("Joined SMS")])], 1)])])]) : (_vm.active_tab == 'video') ? _c('div', {
    staticClass: "profile-videos mt-3"
  }, [_vm._m(4), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((3), function(video) {
    return _c('v-flex', {
      key: video,
      staticClass: "pr-3",
      attrs: {
        "xs4": ""
      }
    }, [_c('video-box', {
      attrs: {
        "hoverOverlay": false,
        "item": _vm.ownVideos[video]
      }
    })], 1)
  })), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.ownVideos), function(video) {
    return _c('v-flex', {
      key: video.name,
      staticClass: "card-container",
      attrs: {
        "xs3": ""
      }
    }, [_c('video-box', {
      attrs: {
        "hoverOverlay": false,
        "item": video
      }
    })], 1)
  }))], 1) : _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "px-0": ""
    }
  }, [(!_vm.albums || _vm.albums.length == 0) ? [(_vm.active_tab == 'songs') ? [(_vm.currentUser && _vm.currentUser.id == _vm.user.id) ? [(_vm.currentUser.creator_verified) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no uploaded albums")]), _vm._v(" "), _c('router-link', {
    staticClass: "empty-discover-btn",
    attrs: {
      "to": "/upload/album"
    }
  }, [_vm._v("Upload")])], 1) : _vm._e()] : [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("\n                  This user has no uploaded albums\n                ")])])]] : (_vm.active_tab == 'downloaded') ? [(_vm.currentUser && _vm.currentUser.id == _vm.user.id) ? [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no downloaded albums")]), _vm._v(" "), _c('router-link', {
    staticClass: "empty-discover-btn",
    attrs: {
      "to": "/album"
    }
  }, [_vm._v("Discover")])], 1)] : [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("\n                  This user has not downloaded any albums\n                ")])])]] : (_vm.active_tab == 'reposted') ? [(_vm.currentUser && _vm.currentUser.id == _vm.user.id) ? [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no reposts")]), _vm._v(" "), _c('router-link', {
    staticClass: "empty-discover-btn",
    attrs: {
      "to": "/album"
    }
  }, [_vm._v("Discover")])], 1)] : [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("This user has no reposts")])])]] : (_vm.active_tab == 'catalog') ? [(_vm.currentUser && _vm.currentUser.id == _vm.user.id) ? [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no catalog")])])] : [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("This user has no catalog")])])]] : _vm._e()] : _c('div', {
    staticClass: "profile-track"
  }, [_c('div', {
    staticClass: "_body list-track-container list-track-view list-track-view-trackCard list-popular-tracks"
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center mt-3 mb-3"
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v("Popular")])]), _vm._v(" "), _vm._l((_vm.albums.slice(0, 5)), function(track, index) {
    return _c('div', {
      key: index,
      staticClass: "list-track-view-item px-5"
    }, [_c('track-card', {
      attrs: {
        "objects": _vm.albums,
        "objectIndex": index,
        "hideMoreMenu": "",
        "hideTrackLength": "",
        "displayDuration": ""
      }
    })], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dflex justify-space-between align-center mt-5 mb-3"
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v("Albums")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.albums.filter(function (t) { return t.collaborators_count == 0; }).slice(0, 6)), function(feed, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "custom-lg6",
      attrs: {
        "xs6": ""
      }
    }, [_c('track-card', {
      attrs: {
        "objects": _vm.albums.filter(function (t) { return t.collaborators_count == 0; }).slice(0, 6),
        "objectIndex": index
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "dflex justify-space-between align-center mt-5 mb-3"
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v("Appears on")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.albums.filter(function (t) { return t.collaborators_count > 0; })), function(feed, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "custom-lg6",
      attrs: {
        "xs6": ""
      }
    }, [_c('track-card', {
      attrs: {
        "objects": _vm.albums.filter(function (t) { return t.collaborators_count > 0; }),
        "objectIndex": index
      }
    })], 1)
  }))], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page_index < _vm.total_pages),
      expression: "page_index < total_pages"
    }],
    staticClass: "loadmore-btn",
    nativeOn: {
      "click": function($event) {
        _vm.getItems(_vm.active_tab, true)
      }
    }
  }, [_vm._v("Load More")])], 2)], 1)], 1), _vm._v(" "), (_vm.showSendMessage) ? _c('send-message', {
    attrs: {
      "receiver": _vm.user,
      "dismiss": _vm.dismissMessageModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSendLoveModal) ? _c('send-love-modal', {
    attrs: {
      "item": _vm.user,
      "dismiss": _vm.dismissLoveDialog
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_block_user_confirm_dialog),
      callback: function($$v) {
        _vm.show_block_user_confirm_dialog = $$v
      },
      expression: "show_block_user_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Block a User")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to block this?")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "color": "black"
    },
    nativeOn: {
      "click": function($event) {
        _vm.blockUser()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "color": "black"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeBlockUserConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_invite_confirm_dialog),
      callback: function($$v) {
        _vm.show_invite_confirm_dialog = $$v
      },
      expression: "show_invite_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-media', {
    attrs: {
      "src": _vm.user.avatar.url,
      "height": "125px",
      "contain": ""
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Do you want to invite this user?\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        This user's account is pending verification. Only verified users can\n        invite pending accounts. Inviting this user will expedite their\n        verification process\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeInviteConfirmDialog()
      }
    }
  }, [_vm._v("No, cancel!")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.inviteUser()
      }
    }
  }, [_vm._v("Yes, Invite!")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": ["membership-dialog"]
    },
    model: {
      value: (_vm.showMembershipModal),
      callback: function($$v) {
        _vm.showMembershipModal = $$v
      },
      expression: "showMembershipModal"
    }
  }, [_c('div', {
    staticClass: "membership-bg-img",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.url + ')'
    })
  }, [_c('div', [_c('h2', {
    staticClass: "memership-title"
  }, [_vm._v(_vm._s(_vm.user.display_name) + " "), _c('img', {
    attrs: {
      "src": require("../../../static/images/ic_check_o.png"),
      "width": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "memership-subtitle"
  }, [_vm._v("Membership")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.monthlyTier = !_vm.monthlyTier
      }
    }
  }, [_vm._v("\n          Switch to " + _vm._s(_vm.monthlyTier ? 'yearly' : 'monthly') + " plan\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex plan-slides"
  }, _vm._l((_vm.membership_tiers), function(tier) {
    return _c('div', [_c('div', {
      staticClass: "member-plan"
    }, [_c('div', {
      staticClass: "plan-title"
    }, [_c('div', {
      staticClass: "plan-main-title"
    }, [_c('h3', [_vm._v(_vm._s(tier.plan_name))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": require("../../../static/images/star.svg")
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "plan-price"
    }, [_c('strong', [_vm._v("$" + _vm._s(parseFloat(tier.price)))]), _vm._v("/" + _vm._s(_vm.monthlyTier ? 'month' : 'year') + "\n                ")]), _vm._v(" "), (_vm.purchasedPlan(tier)) ? _c('span', {
      staticClass: "plan-status"
    }, [_vm._v("\n                  current plan\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "plan-description"
    }, [_c('span', {}, [_vm._v("\n                  " + _vm._s(_vm.fromNow(tier.updated_at)) + "\n                ")]), _vm._v("\n                " + _vm._s(tier.description) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "plan-button-section"
    }, [_c('v-btn', {
      staticClass: "btn member-button",
      on: {
        "click": function($event) {
          _vm.purchaseMembership(tier, _vm.getMembershipId(tier))
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.purchaseMembershipBtnTitle(tier)) + "\n                ")])], 1)])])
  }))])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": ["membership-payment-dialog"]
    },
    model: {
      value: (_vm.showPaymentModal),
      callback: function($$v) {
        _vm.showPaymentModal = $$v
      },
      expression: "showPaymentModal"
    }
  }, [_c('v-card', {
    staticClass: "w-100"
  }, [_c('v-card-title', {
    staticClass: "dflex justify-space-between"
  }, [_c('h2', {
    staticClass: "px-3"
  }, [_vm._v("Payment")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showPaymentModal = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "mb-1"
  }, [_c('div', {
    staticClass: "title mb-2"
  }, [_vm._v("Purchase")])]), _vm._v(" "), _c('div', {
    staticClass: "membership-purchase-section"
  }, [_c('div', {
    staticClass: "header-title"
  }, [_vm._v("\n                Membership purchase\n                "), _c('span', {
    staticClass: "membership-price"
  }, [_vm._v("\n                  $" + _vm._s((this.selectedTier ? (this.selectedTier.price) : null)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "membership-purchase-section-body"
  }, [_vm._v("\n              Your card will be charged every month starting from today\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 mb-1"
  }, [_c('div', {
    staticClass: "title mb-2"
  }, [_vm._v("Credit card")])]), _vm._v(" "), _c('div', {
    staticClass: "payment-stripe-section"
  }, [_c('div', {
    staticClass: "stripe-section-body"
  }, [_c('div', {
    staticClass: "lock"
  }, [_c('card-number', {
    ref: "cardNumber",
    staticClass: "stripe-element card-number payment-card",
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.number = $event.complete
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-image"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/cards.png"),
      "alt": "",
      "width": "130"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-details"
  }, [_c('div', [_c('card-expiry', {
    ref: "cardExpiry",
    staticClass: "stripe-element card-expiry payment-card",
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.expiry = $event.complete
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "question-mark"
  }, [_c('card-cvc', {
    ref: "cardCvc",
    staticClass: "stripe-element card-cvc payment-card",
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.cvc = $event.complete
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "payment-stripe-section-button"
  }, [_c('div', {
    staticClass: "btn-holder"
  }, [_c('v-btn', {
    staticClass: "checkout-btn",
    on: {
      "click": _vm.handlePayment
    }
  }, [_vm._v("Pay $" + _vm._s(_vm.totalPayable()))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "powered-by text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/powered-by.png"),
      "width": "100",
      "alt": ""
    }
  })])])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.purchaseModal),
      callback: function($$v) {
        _vm.purchaseModal = $$v
      },
      expression: "purchaseModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Purchase Membership\n      ")]), _vm._v(" "), (_vm.selectedTier) ? _c('v-card-text', [_vm._v("\n        Are you sure you want to purchase "), _c('b', [_vm._v(_vm._s(_vm.selectedTier.plan_name))]), _vm._v("?\n        This process might take a while. Please don't refresh page in this time.\n        "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "my-2"
  }, [_c('div', {
    staticClass: "d-flex row my-2"
  }, [_c('div', {
    staticClass: "col-10 text-left"
  }, [_vm._v("Membership Price")]), _c('div', {
    staticClass: "col-1 text-right"
  }, [_c('b', [_vm._v("$" + _vm._s(_vm.selectedTier.price))])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex row my-2"
  }, [_c('div', {
    staticClass: "col-10 text-left"
  }, [_vm._v("Stripe Fee")]), _c('div', {
    staticClass: "col-1 text-right"
  }, [_c('b', [_vm._v("$" + _vm._s(_vm.selectedTier.stripe_fee / 100))])])])]), _vm._v(" "), _c('hr'), _vm._v("\n        By clicking "), _c('b', [_vm._v("Yes")]), _vm._v(" you agree to be charged "), _c('b', [_vm._v("$" + _vm._s(_vm.selectedTier.total_price / 100))]), _vm._v(" every " + _vm._s(_vm.selectedTier.plan_type) + ".\n      ")]) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "green",
      "dark": "",
      "block": "",
      "disabled": _vm.stripe_inprogress
    },
    nativeOn: {
      "click": function($event) {
        _vm.purchase()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.hidePurchaseModal()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_order_complete_dialog),
      callback: function($$v) {
        _vm.show_order_complete_dialog = $$v
      },
      expression: "show_order_complete_dialog"
    }
  }, [_c('div', {
    staticClass: "payment-success payment-ready"
  }, [_c('div', {
    staticClass: "dflex align-center my-4"
  }, [_c('div', {
    staticClass: "success-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/true.svg"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "result-text"
  }, [_c('div', {
    staticClass: "big"
  }, [_vm._v("Thank you!")]), _vm._v(" "), _c('div', [_vm._v("Your order was successful")])])]), _vm._v(" "), _c('div', {
    staticClass: "post"
  }, [_vm._v("\n        We sent an email confirmation to: "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" " + _vm._s(_vm.currentUser.email) + " ")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-5 pay_btn",
    attrs: {
      "depressed": "",
      "round": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: ("/members/" + (_vm.user.slug))
        })
      }
    }
  }, [_vm._v("View members area")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have not added any user")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("\n                This user has not added any user\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("This user has no products")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sms-info"
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('div', {
    staticClass: "sms-img"
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-2"
  }, [_c('div', {
    staticClass: "sms-name dflex align-center"
  }, [_vm._v("\n                  Tribe Nohbi\n                  "), _c('img', {
    staticClass: "ml-1",
    attrs: {
      "src": require("../../assets/true.svg"),
      "width": "10"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-type"
  }, [_vm._v("\n                  Artist\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex justify-space-between align-center"
  }, [_c('div', {
    staticClass: "text-big mb-2"
  }, [_vm._v("Popular")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex justify-space-between align-center margin-top-x"
  }, [_c('div', {
    staticClass: "text-big mb-2"
  }, [_vm._v("Videos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-401cdb90","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/profile.vue
// module id = 1693
// module chunks = 180